import React, {FC} from 'react';
import styles from "./styles/ListItemGroup.module.scss";
import {observer} from "mobx-react";
import classNames from 'classnames';
import {
    IReactiveCourseWorkContentItem,
    IReactiveEventContentItem,
    IReactiveFileContentItem,
    IReactiveFolderContentItem,
    IReactiveMediaContentItem,
    IReactiveNewsContentItem,
} from "../SchoolFeedContentItem";
import {handleContentItemClick,} from "../../blocks/SchoolBlocks/ContentItemBlock/ContentItemBlock";
import {SocialItemModalNavigationProps} from "../../modals/SocialItemModal";
import {LocaleContextProvider} from "../../../utils/LocaleContext";
import {Media} from "./Media";
import {Item} from "./Item";
import {getListItemIndex, isNews, unpublishItem} from "./utils";
import {deleteContentItem} from "../../blocks/TerracedGridTheme/Terrace";

export const scrollItemId = "scroll-item-news";

const ListItemGroup: FC<{
    items: Array<IReactiveEventContentItem | IReactiveNewsContentItem | IReactiveCourseWorkContentItem | IReactiveFolderContentItem | IReactiveFileContentItem | IReactiveMediaContentItem>,
    allowCuration: boolean,
    showMedia: boolean,
    handleDelete?: (c: ContentItem) => void,
    handleKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>) => void,
} & Omit<SocialItemModalNavigationProps, "initialItemIndex">> = observer(props => {
    const firstItem = props.items[0];

    async function deleteItem(item: IReactiveNewsContentItem | IReactiveEventContentItem) {
        await deleteContentItem(item);
        if (props.handleDelete) {
            props.handleDelete(item);
        }
    }

    const groupContainerClassName = classNames({
        [styles.groupContainer]: true,
        [styles.groupContainerNews]: isNews(firstItem),
        [styles.groupContainerCenteredImage]: firstItem.image && props.items.length > 1,
    })


    return <div className={groupContainerClassName}>
        {props.showMedia && <Media itemObj={firstItem} style={styles.dateMedia} onClick={(e) => {
            e.stopPropagation();
            handleContentItemClick(firstItem, {
                getItemAtIndex: props.getItemAtIndex,
                totalItemCount: props.totalItemCount,
                initialItemIndex: getListItemIndex(firstItem.id.toString()),
            },
                deleteItem,
            )
        }
        }/>}
        <div className={styles.contentContainer}>
            {props.items.map((item, idx) => {
                return <LocaleContextProvider locale={item.language} key={item.id}>
                    <Item
                        allowCuration={props.allowCuration}
                        itemObj={item}
                        deleteItem={deleteItem}
                        unpublishItem={unpublishItem}
                        handleClick={() => handleContentItemClick(item, {
                            getItemAtIndex: props.getItemAtIndex,
                            totalItemCount: props.totalItemCount,
                            initialItemIndex: getListItemIndex(item.id.toString()),
                        },
                            deleteItem,
                        )}
                        handleKeyDown={props.handleKeyDown}
                    />
                </LocaleContextProvider>
            })}
        </div>
    </div>
})

export default ListItemGroup
